<template>
    <div class="lab-item">
      <span class="status-text">{{statusText}}</span>
      <div class="content">
        <h5 class="title">{{ title }}</h5>
        <p class="description">{{ description }}</p>
      </div>
      <slot name="button"></slot>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: true
      },
      statusText: {
        type: String,
        required: false
      },
    }
  };
  </script>
  
  <style scoped>
  .lab-item {
    background-color: var(--card-bg);
    box-shadow: 0 10px 15px -3px var(--shadow-color), 0 4px 6px -2px var(--shadow-color);
    border-radius: 1rem;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    margin-left: 2rem;
    margin-right: 2rem;
    width: 35%;
    border: 1px solid var(--border-color);
    min-height: 250px;
    box-sizing: border-box;
  }
  
  .lab-item:hover {
    transform: scale(1.05);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  
  .title {
    font-size: 0.9rem;
    font-weight: bold;
    color: var(--text-primary);
  }

  .status-text {
    color: #ff4444;
    font-size: 0.5rem;
    font-weight: bold;
    min-height: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 110px;
  }
  
  .description {
    color: var(--text-secondary);
    margin-top: 0.5rem;
    justify-content: center;
    text-align: center;
  }
  
  :deep(.btn) {
    margin-top: 1rem;
    background-color: #059669;
    color: white;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    border-radius: 0.3rem;
    text-align: center;
    font-weight: 300;
    font-size: 0.7rem;
  }
  
  :deep(.btn:hover) {
    background-color: #047857;
  }


@media (max-width: 750px) {
  .title {
    font-size: 0.5rem;
  }

  :deep(.btn) {
    font-size: 0.4rem;
  }

  .lab-item {
    background-color: var(--card-bg);
    width: 80%;
    min-height: 220px;
  }
  
}
  </style>